import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';
import DashboardCourseCard from '@core/components/dashboardcoursecard/DashboardCourseCard';

import classes from './ContinueCourses.module.scss';



const ContinueCourses = ({ data }) => {
    return (
        <>
            {(data.length > 0) ? (
                <div className='d-flex flex-wrap justify-content-center justify-content-md-start gap-3'>
                    {data.map((course) => (
                        <DashboardCourseCard data={course} />
                    ))}
                </div>
            ) : (
                <div className={classes.wrapper}>
                    <div className={classes['empty-state']}>
                        <h5>No Courses in-Progress!</h5>
                        <p>Discover new topics and expand your knowledge. Find a course that interests you!</p>
                        <LinkButton kind='primary-color' to={'/explore'}>
                            Explore Courses
                        </LinkButton>
                    </div>
                </div >
            )}

        </>

    );
};

export default ContinueCourses;